import { Account } from '@frontend/account/types';
import { useAppSelector } from '@frontend/common';
import { useAccountRepository } from '@frontend/repository';
import { fetchProfile, userStore } from '@frontend/user/redux';
import { IUser } from '@frontend/user/types';
import { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';

import { useAppDispatch } from '../redux/store';

interface ViewProps {
    onChangeMembership: (value: string | null) => void;
    accounts: Account[];
    selectedAccount: Account | null;
    user: IUser | undefined;
    isSwitching: boolean;
}

const useAccountMembership = (): ViewProps => {
    const accountInfo = useAccountRepository();
    const accounts = useMemo(() => accountInfo.store.availableAccountsInfo, [accountInfo.store.availableAccountsInfo]);
    const [selectedAccount, changeSelectedAccount] = useState<Account | null>(null);
    const [isSwitching, setIsSwitching] = useState(false);
    const dispatch = useAppDispatch();
    const userState = useAppSelector(useSelector, userStore);
    const user = userState.current ?? undefined;

    useEffect(() => {
        dispatch(fetchProfile());
    }, [dispatch]);

    useEffect(() => {
        const next = accounts.find((acc) => acc.id === accountInfo.store.currentAccount) ?? null;
        changeSelectedAccount((prev) => (prev?.id === next?.id ? prev : next));
    }, [accountInfo.store.currentAccount, accounts]);

    const onChangeMembership = async (value: string | null) => {
        if (!value || isSwitching || value === accountInfo.store.currentAccount) {
            return;
        }
        setIsSwitching(true);
        try {
            await accountInfo.updateCurrentAccount(value);
            window.location.reload();
        } catch {
            setIsSwitching(false);
        }
    };

    return {
        onChangeMembership,
        selectedAccount,
        accounts,
        user,
        isSwitching
    };
};

export default useAccountMembership;
